import {
  ADD_NEW_USER,
  ADD_NEW_USER_FAILED,
  ADD_NEW_USER_SUCCESS,
  ASSIGN_CODE,
  ASSIGN_CODE_FAILED,
  ASSIGN_CODE_SUCCESS,
  DELETE_BATCH,
  DELETE_BATCH_FAILED,
  DELETE_BATCH_SUCCESS,
  GENERATE_CODE,
  GENERATE_CODE_FAILED,
  GENERATE_CODE_SUCCESS,
  GET_CODES_LIST,
  GET_CODES_LIST_FAILED,
  GET_CODES_LIST_SUCCESS,
  GET_CODE_BATCH,
  GET_CODE_BATCH_FAILED,
  GET_CODE_BATCH_SUCCESS,
  HIDE_ASSIGN_CODE_MODAL,
  HIDE_CREATE_USER_MODAL,
  HIDE_REASSIGN_CODE_MODAL,
  HIDE_REINSTATE_CODE_MODAL,
  OPEN_ASSIGN_CODE_MODAL,
  OPEN_CREATE_USER_MODAL,
  OPEN_REASSIGN_CODE_MODAL,
  OPEN_REINSTATE_CODE_MODAL,
  REASSIGN_CODE,
  REASSIGN_CODE_FAILED,
  REASSIGN_CODE_SUCCESS,
  REINSTATE_CODE,
  REINSTATE_CODE_FAILED,
  REINSTATE_CODE_SUCCESS,
  RESET_CREATED_USER,
  RETRY_BATCH,
  RETRY_BATCH_FAILED,
  RETRY_BATCH_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  codes: null,
  batch: [],
  assignCodeModalIsOpen: false,
  createUserModalIsOpen: false,
  createdUser: null,
  reassignCodeModalIsOpen: false,
  reinstateCodeModalIsOpen: false,
}

const codes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CODES_LIST:
    case GET_CODE_BATCH:
    case RETRY_BATCH:
    case ADD_NEW_USER:
    case ASSIGN_CODE:
    case REINSTATE_CODE:
    case REASSIGN_CODE:
    case GENERATE_CODE:
    case DELETE_BATCH:
      return {
        ...state,
        loading: true,
      }
    case GET_CODES_LIST_FAILED:
    case GET_CODE_BATCH_FAILED:
    case RETRY_BATCH_FAILED:
    case ADD_NEW_USER_FAILED:
    case ASSIGN_CODE_FAILED:
    case REINSTATE_CODE_FAILED:
    case REASSIGN_CODE_FAILED:
    case GENERATE_CODE_FAILED:
    case DELETE_BATCH_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_CODES_LIST_SUCCESS:
      return {
        ...state,
        codes: action.payload,
        loading: false,
      }
    case GET_CODE_BATCH_SUCCESS:
    case RETRY_BATCH_SUCCESS:
    case GENERATE_CODE_SUCCESS:
    case DELETE_BATCH_SUCCESS:
      return {
        ...state,
        batch: action.payload,
        loading: false,
      }
    case OPEN_ASSIGN_CODE_MODAL:
      return {
        ...state,
        assignCodeModalIsOpen: true,
      }
    case HIDE_ASSIGN_CODE_MODAL:
      return {
        ...state,
        assignCodeModalIsOpen: false,
      }
    case OPEN_CREATE_USER_MODAL:
      return {
        ...state,
        createUserModalIsOpen: true,
      }
    case HIDE_CREATE_USER_MODAL:
      return {
        ...state,
        createUserModalIsOpen: false,
      }
    case ADD_NEW_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        createdUser: action.payload,
      }
    case RESET_CREATED_USER:
      return {
        ...state,
        createdUser: null,
      }
    case OPEN_REASSIGN_CODE_MODAL:
      return {
        ...state,
        reassignCodeModalIsOpen: true,
      }
    case HIDE_REASSIGN_CODE_MODAL:
      return {
        ...state,
        reassignCodeModalIsOpen: false,
      }
    case OPEN_REINSTATE_CODE_MODAL:
      return {
        ...state,
        reinstateCodeModalIsOpen: true,
      }
    case HIDE_REINSTATE_CODE_MODAL:
      return {
        ...state,
        reinstateCodeModalIsOpen: false,
      }
    case ASSIGN_CODE_SUCCESS:
    case REINSTATE_CODE_SUCCESS:
    case REASSIGN_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}

export default codes
